import {
  useWindowSize,
  constants,
  Breadcrumbs,
  CollapsibleBreadcrumbs,
} from "@newsela/angelou";
import PropTypes from "prop-types";

const propTypes = {
  /**
   * CSS object. Required.
   */
  breadcrumbsCss: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Breadcrumbs array of links. Required.
   */
  breadcrumbsLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      contents: PropTypes.string,
      disclosureLinks: PropTypes.arrayOf(
        PropTypes.shape({
          href: PropTypes.string,
          contents: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  /**
   * Sets when breadcrumbs should and should not collapse.
   */
  windowBreakpoint: PropTypes.number,
};

const DynamicBreadcrumbs = ({
  breadcrumbsCss,
  breadcrumbsLinks,
  windowBreakpoint = null,
}) => {
  const {
    breakpoints: { Breakpoints },
  } = constants;
  const { width: windowWidth } = useWindowSize();
  const windowRestraint = windowBreakpoint || Breakpoints.xs;

  const BreadcrumbsDefault = () => (
    <Breadcrumbs __css={breadcrumbsCss} links={breadcrumbsLinks} />
  );

  const BreadcrumbsCollapsible = () => (
    <CollapsibleBreadcrumbs __css={breadcrumbsCss} links={breadcrumbsLinks} />
  );

  if (windowWidth > windowRestraint) return <BreadcrumbsDefault />;

  return <BreadcrumbsCollapsible />;
};

DynamicBreadcrumbs.propTypes = propTypes;

export default DynamicBreadcrumbs;
